import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { assistenteService } from './assistenteService';
import { BlocosMia } from './BlocosMia';
import { lerBlocos } from './lerBlocosMia';
import { AvatarMia } from './ItemFioMia';
import { SugestoesMomentoMia } from './SugestoesMomentoMia';
import { sortearSugestoesMia } from './sugestoesIniciaisMia';
import { TextoAssistente } from './TextoAssistente';
import styles from './AssistenteWidget.module.css';

type Props = {
  acoes: readonly number[];
  idEscola: number | null;
  desabilitado: boolean;
  onPerguntar: (pergunta: string) => void;
};

/**
 * Conversa vazia (R26): saudacao com o resumo do dia (agenda, notificacoes nao lidas,
 * pendencias), uma apresentacao curta e perguntas sorteadas. O /novidades repete o resumo.
 */
export function AberturaMia({ acoes, idEscola, desabilitado, onPerguntar }: Props) {
  const [sugestoes] = useState(() => sortearSugestoesMia(acoes));
  const novidades = useQuery({
    queryKey: ['assistente', 'novidades', idEscola],
    queryFn: assistenteService.novidades,
    staleTime: 30_000,
  });
  const blocos = novidades.data ? lerBlocos(novidades.data.blocos) : [];
  return (
    <div className={`${styles.linha} ${styles.linhaAssistente}`}>
      <AvatarMia />
      <div className={`${styles.balaoAssistente} ${styles.abertura}`}>
        {novidades.data ? <TextoAssistente texto={novidades.data.texto} /> : null}
        <BlocosMia blocos={blocos} onPerguntar={onPerguntar} desabilitado={desabilitado} />
        <p className={styles.aberturaApresentacao}>
          Sou a <strong>Mia</strong> (<em>Momy Inteligência Artificial</em>). Posso explicar uma tela, achar um aluno,
          indicar o caminho ou preparar um registro. Gravar só acontece se você confirmar. Digite <strong>/</strong> para
          ver os atalhos (<strong>/novidades</strong> repete este resumo); <strong>Ctrl+K</strong> me abre ou minimiza.
        </p>
        {/* Sem o resumo (falhou ou ainda nao chegou), as sugestoes do momento cobrem o que esta pendente. */}
        {novidades.data ? null : (
          <SugestoesMomentoMia desabilitado={desabilitado} onPerguntar={onPerguntar} />
        )}
        <div className={styles.sugestoesIniciais} aria-label="Sugestões">
          {sugestoes.map((sugestao) => (
            <button
              key={sugestao}
              type="button"
              className={styles.sugestao}
              disabled={desabilitado}
              onClick={() => onPerguntar(sugestao)}
            >
              {sugestao}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
